//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Modal from './modal.vue';
export default {
  components: {
    Modal: Modal
  },
  data: function data() {
    return {
      showModalId: 0,
      items: [{
        id: 'img01',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_01_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_01.jpg'
      }, {
        id: 'img02',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_02_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_02.jpg'
      }, {
        id: 'img03',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_03_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_03.jpg'
      }, {
        id: 'img04',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_04_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_04.jpg'
      }, {
        id: 'img05',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_05_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_05.jpg'
      }, {
        id: 'img06',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_06_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_06.jpg'
      }, {
        id: 'img07',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_07_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_07.jpg'
      }, {
        id: 'img08',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_08_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_08.jpg'
      }, {
        id: 'img09',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_09_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_09.jpg'
      }, {
        id: 'img10',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_10_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_10.jpg'
      }, {
        id: 'img11',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_11_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_11.jpg'
      }, {
        id: 'img12',
        thumb: '/assets/img/aboutus/giontsujiri/index_modal_img_12_thumb.jpg',
        img: '/assets/img/aboutus/giontsujiri/index_modal_img_12.jpg'
      }]
    };
  },
  methods: {
    showModal: function showModal(id) {
      this.showModalId = id;
    },
    hideModal: function hideModal() {
      this.showModalId = 0;
    }
  }
};